<template>
  <div class="container settings-wrapper p-1">
    <custom-alert
      class="mr-35"
      items-center
      icon-name="InfoAlt"
    >
      Healthcheck status needs to be disabled for the changed settings to be
      applied.
    </custom-alert>
    <div class="d-flex justify-content-between align-items-center">
      <div class="settings-title">
        <h6 class="text-lg text-main text-left">
          Enable SSL certificate verification
        </h6>
        <p class="text-sm text-secondary">
          Verify SSL certificates when sending a request. Verification failures
          will result in the request being aborted.
        </p>
      </div>
      <div
        class="ml-1"
        style="width: 76px;"
      >
        <b-form-checkbox
          v-if="editable && state === false"
          v-model="healthcheck.certificateVerification"
          :disabled="!editable"
          name="check-button"
          switch
          inline
        >
          {{ healthcheck.certificateVerification ? 'ON' : 'OFF' }}
        </b-form-checkbox>
        <span v-else>
          {{ healthcheck.certificateVerification ? 'ON' : 'OFF' }}
        </span>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="settings-title">
        <h6 class="text-lg text-main text-left">
          Automatically follow redirects
        </h6>
        <p class="text-sm text-secondary">
          Follow HTTP 3xx responses as redirects.
        </p>
      </div>
      <div
        class="ml-1"
        style="width: 76px;"
      >
        <b-form-checkbox
          v-if="editable && state === false"
          v-model="healthcheck.followRedirects"
          :disabled="!editable"
          name="check-button"
          switch
          inline
        >
          {{ healthcheck.followRedirects ? 'ON' : 'OFF' }}
        </b-form-checkbox>
        <span v-else>
          {{ healthcheck.followRedirects ? 'ON' : 'OFF' }}
        </span>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="settings-title">
        <h6 class="text-lg text-main text-left">
          Follow original HTTP Method
        </h6>
        <p class="text-sm text-secondary">
          Redirect with the original HTTP method instead of the default behavior
          of redirecting with GET.
        </p>
      </div>
      <div
        class="ml-1"
        style="width: 76px;"
      >
        <b-form-checkbox
          v-if="editable && state === false"
          v-model="healthcheck.followHttpMethod"
          :disabled="!editable"
          name="check-button"
          switch
          inline
        >
          {{ healthcheck.followHttpMethod ? 'ON' : 'OFF' }}
        </b-form-checkbox>
        <span v-else>
          {{ healthcheck.followHttpMethod ? 'ON' : 'OFF' }}
        </span>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="settings-title">
        <h6 class="text-lg text-main text-left">
          Follow Authorization header
        </h6>
        <p class="text-sm text-secondary">
          Retain authorization header when a redirect happens to a different
          hostname.
        </p>
      </div>
      <div
        class="ml-1"
        style="width: 76px;"
      >
        <b-form-checkbox
          v-if="editable && state === false"
          v-model="healthcheck.followAuthorizationHeader"
          :disabled="!editable"
          name="check-button"
          switch
          inline
        >
          {{ healthcheck.followAuthorizationHeader ? 'ON' : 'OFF' }}
        </b-form-checkbox>
        <span v-else>
          {{ healthcheck.followAuthorizationHeader ? 'ON' : 'OFF' }}
        </span>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="settings-title">
        <h6 class="text-lg text-main text-left">
          Remove referer header on redirect
        </h6>
        <p class="text-sm text-secondary">
          Remove the referer header when a redirect happens.
        </p>
      </div>
      <div
        class="ml-1"
        style="width: 76px;"
      >
        <b-form-checkbox
          v-if="editable && state === false"
          v-model="healthcheck.removeRefererOnRedirect"
          :disabled="!editable"
          name="check-button"
          switch
          inline
        >
          {{ healthcheck.removeRefererOnRedirect ? 'ON' : 'OFF' }}
        </b-form-checkbox>
        <span v-else>
          {{ healthcheck.removeRefererOnRedirect ? 'ON' : 'OFF' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestSettings',
  components: {},
  props: {
    healthcheck: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    state: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>
